module.exports = __webpack_public_path__ + "img/INFINITI.d5bd2df.jpg";